import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import about from '@/components/about'
import product from '@/components/product'
import job from '@/components/job'
import news from '@/components/news'
import contact from '@/components/contact'
import certificate from '@/components/certificate'
import memorabilia from '@/components/memorabilia'



Vue.use(Router)

export default new Router({
  mode: 'history',
  fallback: false,
  routes: [
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/about',//和router-link to相呼应，导航到/about
      name: 'about',
      component: about
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/job',
      name: 'job',
      component: job
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/certificate',
      name: 'certificate',
      component: certificate
    },
    {
      path: '/memorabilia',
      name: 'memorabilia',
      component: memorabilia
    },
    {
      path: '*',
      redirect: '/index'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ selector: to.hash, offset: { x: 0, y: 65 } })
        }, 100)
      })
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js